// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Checnovskaya <anastasia.chesnovskaya@celadon.ae>
import GlobalStyles from '../../../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '20px 10px',
    borderRadius: 20,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,

    [theme.breakpoints.down(600)]: {
      boxShadow: 'none',
      borderRadius: 0,
      margin: 0,
      width: '100%',
      marginBottom: 50,
    },
  },
  topContainer: {
    position: 'relative',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    padding: '10px 30px',
    justifyContent: 'space-between',
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,

    [theme.breakpoints.down(600)]: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
    [theme.breakpoints.down(400)]: {
      padding: '10px 10px',
      fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
    },
  },
  arrowBackContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  orderTime: {
    marginLeft: 5,
  },
  processing: {
    backgroundColor: GlobalStyles.color.COLOR_REJECT,
  },
  paid: {
    backgroundColor: GlobalStyles.color.COLOR_GREEN,
  },
  default: {
    backgroundColor: GlobalStyles.color.COLOR_DEFAULT,
  },
  contentContainer: {
    width: '90%',
    margin: '20px 0',
    display: 'flex',
    flexDirection: 'column',
  },
  contentTopContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  loaderContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 10,
  }
});

export default styles;
